module.exports = __webpack_public_path__ + "static/media/tutorial_background.d248b729.png";